import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { ApiResponse } from 'src/app/main/_models/api-response';
import { ApiDatatableResponse } from 'src/app/main/_models/api-datatable-response';

@Injectable({
	providedIn: 'root'
})
export class VehicleService {

	constructor(private http: HttpClient,
		private config: AppConfig) { }

	datatable(data) {
		return this.http.post<ApiDatatableResponse>(`${this.config.getConfig("apiEndpoint")}/vehicles/dt`, data);
	}

	getCategoriesByMaxPax(maxPasseggeri: number) {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/vehicles/categories?f=add&p=` + maxPasseggeri);
	}

	getAllCategories() {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/vehicles/categories`);
	}

	getAll() {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/vehicles/all`);
	}

	get(id: number) {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/vehicles/` + id);
	}

	delete(id: number) {
		return this.http.delete<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/vehicles/` + id);
	}

	update(v: any) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/vehicles`, v);
	}

	wizardInsert(v: any) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/vehicles/wizard`, v);
	}

	insert(v: any) {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/vehicles`, v);
	}


}
